export const commonTextAreaContent = {
    type: 'Type your message ',
    guide: '(1 part SMS = 160 Characters)',
    charactersUsed: 'Characters Used: ',
    messagedUsed: 'Message: ',
    limit: 1000
}
